// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ANHZMQQrEoGrWinfXohR {
  overflow: hidden
}
.ANHZMQQrEoGrWinfXohR .trTsWbh9c0LLscgkyMZo {
    cursor: pointer;
    position: relative;
    z-index: 1;
  }
.ANHZMQQrEoGrWinfXohR .QsVNVHvq7kov7l0Dr0pO {
    transition: margin-top 200ms
  }
.ANHZMQQrEoGrWinfXohR .QsVNVHvq7kov7l0Dr0pO.Owtpm6eYRQ5xpsXCNuCt {
      --children-height: unset;

      margin-top: calc(-1 * var(--children-height));
    }`, "",{"version":3,"sources":["webpack://./node_modules/@nxte-nl/collapse-panel/src/CollapsePanel.module.css"],"names":[],"mappings":"AAAA;EACE;AAiBF;AAfE;IACE,eAAe;IACf,kBAAkB;IAClB,UAAU;EACZ;AAEA;IACE;EAOF;AALE;MACE,wBAAwB;;MAExB,6CAA6C;IAC/C","sourcesContent":[".collapsePanel {\n  overflow: hidden;\n\n  & .header {\n    cursor: pointer;\n    position: relative;\n    z-index: 1;\n  }\n\n  & .children {\n    transition: margin-top 200ms;\n\n    &.collapsed {\n      --children-height: unset;\n\n      margin-top: calc(-1 * var(--children-height));\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"collapsePanel": `ANHZMQQrEoGrWinfXohR`,
	"header": `trTsWbh9c0LLscgkyMZo`,
	"children": `QsVNVHvq7kov7l0Dr0pO`,
	"collapsed": `Owtpm6eYRQ5xpsXCNuCt`
};
export default ___CSS_LOADER_EXPORT___;
